import { createAction } from 'Lib/reduxUtils';

import {
  FETCH_EMAIL_SUBSCRIPTIONS,
  FETCH_EMAIL_SUBSCRIPTIONS_ERROR,
  FETCH_EMAIL_SUBSCRIPTIONS_SUCCESS,
  SET_USER_TOKEN_ERROR,
  SET_USER_TOKEN_SUCCESS,
  UPDATE_EMAIL_SUBSCRIPTIONS,
  UPDATE_EMAIL_SUBSCRIPTIONS_ERROR,
  UPDATE_EMAIL_SUBSCRIPTIONS_SUCCESS,
} from './constants';
import { Subscription } from './types';

export const setUserTokenSuccess = createAction(SET_USER_TOKEN_SUCCESS, (token: string) => ({
  token,
}));
export const setUserTokenError = createAction(SET_USER_TOKEN_ERROR);

export const fetchEmailSubscriptions = createAction(FETCH_EMAIL_SUBSCRIPTIONS, (token: string) => ({
  token,
}));
export const fetchEmailSubscriptionsSuccess = createAction(
  FETCH_EMAIL_SUBSCRIPTIONS_SUCCESS,
  (subscriptions: Subscription[]) => ({ subscriptions })
);
export const fetchEmailSubscriptionsError = createAction(FETCH_EMAIL_SUBSCRIPTIONS_ERROR);

export const updateEmailSubscriptions = createAction(
  UPDATE_EMAIL_SUBSCRIPTIONS,
  (token: string, subscriptions: Subscription[]) => ({ token, subscriptions })
);
export const updateEmailSubscriptionsSuccess = createAction(UPDATE_EMAIL_SUBSCRIPTIONS_SUCCESS);
export const updateEmailSubscriptionsError = createAction(UPDATE_EMAIL_SUBSCRIPTIONS_ERROR);
